<mat-progress-bar mode="indeterminate" class="audio-progress-bar" [hidden]="!progessBarStatus"></mat-progress-bar>
<div class="cross-window-tools d-flex align-items-center justify-content-center">
  <div class="cross-window-tool d-flex align-items-center justify-content-center"
    *ngIf="enableMinimization" (click)="emitMinimizeMessage()">
    <mat-icon>minimize</mat-icon>
  </div>
  <div class="cross-window-tool d-flex align-items-center justify-content-center"
    *ngIf="enableClose" (click)="emitCloseMessage()">
    <mat-icon>close</mat-icon>
  </div>
</div>
<div class="container pr-0 pl-0">
  <div class="col-xs-12">
    <div *ngIf="configLoaded">
      <router-outlet *ngIf="true"></router-outlet>
    </div>
  </div>
</div>
<app-livechat-status *ngIf="showLiveChatStatus" [data]="messengerService.LivechatStatus" [sessionId]="sessionId">
</app-livechat-status>

<div id="overlay" *ngIf="browserCheckEnabled && !isBrowserValid"
  [ngStyle]="{'opacity': browserCheckEnabled === true ? '0.9' : '0', 'background': browserCheckEnabled === true ? '#fff' : '0'}">
</div>
<div class="shadowed-box-container" *ngIf="browserCheckEnabled && !isBrowserValid">
  <div class="shadowed-box">
    <img src="assets/images/error-outline.svg" alt="" srcset="">
    <h4>Browser not Supported</h4>
    <p>Current browser doesn't provide support for audio video calls, we recommend opening this link in Chrome, Edge or
      Safari</p>
  </div>
</div>
<div class="footer" *ngIf="appConfig?.showVersion">
  {{appVersion}}
</div>
 
<app-annotation *ngIf="formsService.showAnnotateContainer && (isChatbotMode || who == 'agent')" [annotationIndex]="formsService.annotationIndex"
  [sourceImage]="formsService.activeAnnotateImage" (annotateObject)="onDoneAnnotate($event)"></app-annotation>